export default __webpack_public_path__ + "static/media/shop_gems_background.9239aaca.png";